<template>
  <div id="timeLimit">
    <div class="tabBox" :class="{ 'tab-fixed': isTabFixed }">
      <div class="item" :class="{active: index === currentIndex}" v-for="(item, index) in tabList" :key="index" @click="handleTab(item, index)">
        {{ item.name }}
      </div>
    </div>
    <div class="masterMap">
      <img src="../../../assets/images/activity/masterMap.jpg" alt="">
      <img class="goBack" @click="goBack" src="../../../assets/images/activity/goBack.png" alt="">
    </div>
    <div class="content">
      <div class="titleBox">
        <span class="title">
          {{ statusOrder === 1 ? '正在疯抢' : statusOrder === 2 ? '即将开抢' : '已结束' }}
          <!-- 装饰-左 -->
          <div class="decoration decoration_left left">
            <div class="decoration-line"></div>
          </div>
          <!-- 装饰-右 -->
          <div class="decoration right">
            <div class="decoration-line"></div>
          </div>
        </span>
      </div>
      <template v-if="flashSaleList.length > 0">
        <div class="limitList" v-for="(item, index) of flashSaleList" :key="index">
          <div class="limitImg" @click="item.countdownStatus === 'ended'? handleEnd(item) : ''">
            <img :src="item.imgUrl" alt="">
            <div class="look" @click="handleLook(item)" v-if="item.countdownStatus !== 'ended'">
              查看更多
              <i class="el-icon-arrow-right"></i>
            </div>
            <div v-if="item.countdownStatus !== 'ended'" class="time" :class="{'time-ongoing': item.countdownStatus === 'ongoing', 'time-upcoming': item.countdownStatus === 'upcoming'}">
              <span v-if="item.countdownText">{{ item.countdownText }}</span>
            </div>
          </div>
          <div class="limitItem" v-if="statusOrder === 1 || statusOrder === 2">
            <div class="limitItemBox" v-for="(value, key) in item.shopCommodityList" :key="key">
              <div class="img">
                <img :src="value.imgs[0].img" alt="">
                <img class="soldOut" v-if="value.showStock <= 0" src="../../../assets/images/activity/soldOut.png" alt="">
              </div>
              <div class="info">
                <div class="storeCommodity">
                  <img class="UImg" v-if="value.storeType === 'U'" src="@/assets/images/pt-yxdp.png" alt="">
                  <img class="SImg" v-if="value.storeType === 'S'" src="@/assets/images/pt-yxdp.png" alt="">
                  <div class="commodityName">{{ value.commodityName }}</div>
                </div>
                <div class="progressBar" v-if="value.showStock > 0">
                  <el-progress :stroke-width="12" :percentage="value.progress" color="#EB6643" define-back-color="#fff" text-color="#EB6643"></el-progress>
                </div>
                <div class="progressBar" v-else>
                  <el-progress :stroke-width="12" :percentage="100" color="#EB6643" define-back-color="#fff" text-color="#EB6643"></el-progress>
                </div>
                <div class="price">
                  <div class="price-box" v-if="value.pays[0].payType === 1">
                    <div class="current-price">
                      <span style="font-size: 10px;margin-right: -4px;">¥</span>
                      {{ minRetailPrice(value.activitySkus, 'discountValue')?.discountValue }}
                    </div>
                    <div class="original-price">
                      <span style="font-size: 10px;margin-right: -2px;">¥</span>
                      {{ minRetailPrice(value.activitySkus, 'discountValue')?.retailPrice }}
                    </div>
                  </div>
                  <div class="price-box" v-else>
                    <div class="current-price">
                      {{ minRetailPrice(value.activitySkus, 'discountValue')?.discountValue }}
                      {{ value.pays[0].symbolNameCh }}
                    </div>
                    <div class="original-price">
                      {{ minRetailPrice(value.activitySkus, 'discountValue')?.retailPrice }}
                      {{ value.pays[0].symbolNameCh }}
                    </div>
                  </div>
                  <div class="btn" v-if="value.showStock > 0 && statusOrder === 1" @click="handleBuy(item, value.commodityId)">立即抢购</div>
                  <div class="btn" v-else-if="statusOrder === 2" @click="handleBuy(item, value.commodityId)">即将开抢</div>
                  <div class="btn" style="opacity: 0.5;" v-else>已售罄</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="noData" v-else>
        暂无数据
      </div>
    </div>
    <!-- 加载状态提示 -->
    <div v-if="flashSaleList.length > 0" class="loadingTip">
      <div v-if="loading" class="loading">正在加载<i class="el-icon-loading"></i></div>
      <div v-else-if="noMore" class="noMore">没有更多了</div>
    </div>
  </div>
</template>

<script>
/*global protocol http */
export default {
  data() {
    return {
      flashSaleList: [],
      tabList: [
        {
          name: '正在疯抢',
          value: 1
        },
        {
          name: '即将开抢',
          value: 2
        },
        {
          name: '已结束',
          value: 3
        }
      ],
      currentIndex: 0,
      statusOrder: 1, // 活动状态  1进行中, 2即将开始 , 3已结束
      PREHEAT_TIME: null, // 预热时间
      timer: null, // 倒计时定时器
      isTabFixed: false, // 标签是否固定
      tabOffsetTop: 0, // 标签初始位置
      currentPage: 0, // 当前页码
      pageSize: 10, // 每页数量
      loading: false, // 加载中状态
      noMore: false, // 是否没有更多数据
      totalPages: 0 // 总页数
    }
  },
  computed: {
    // 从 Vuex 获取服务器时间偏移量
    serverTimeOffset() {
      return this.$store.state.common.serverTimeOffset || 0
    }
  },
  created() {
    // 从 Vuex 恢复 statusOrder（仅在从详情页返回时）
    const savedStatusOrder = this.$store.state.pt.timeLimitStatusOrder
    if (savedStatusOrder) {
      this.statusOrder = savedStatusOrder
      this.currentIndex = this.tabList.findIndex(item => item.value === this.statusOrder)
      // 恢复后立即清除，避免下次新进入时还保持这个状态
      this.$store.commit('pt/setTimeLimitStatusOrder', null)
    }
    this.queryAllflashSale()
  },
  mounted() {
    this.$nextTick(() => {
      // 获取tabBox的初始位置
      const tabBox = document.querySelector('.tabBox')
      if (tabBox) {
        this.tabOffsetTop = tabBox.offsetTop
      }
      // 监听#app容器的滚动事件
      const appContainer = document.querySelector('#app')
      if (appContainer) {
        appContainer.addEventListener('scroll', this.handleScroll)
      }
    })
  },
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    // 移除滚动监听
    const appContainer = document.querySelector('#app')
    if (appContainer) {
      appContainer.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    // 处理滚动事件
    handleScroll() {
      const appContainer = document.querySelector('#app')
      const scrollTop = appContainer ? appContainer.scrollTop : 0
      this.isTabFixed = scrollTop >= this.tabOffsetTop

      // 如果正在加载或没有更多数据，则不处理
      if (this.loading || this.noMore) return

      // 获取滚动位置
      const scrollHeight = appContainer ? appContainer.scrollHeight : 0
      const clientHeight = appContainer ? appContainer.clientHeight : 0

      // 判断是否滚动到底部（距离底部100px时触发）
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        this.loadMore()
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    // 格式化时间为两位数
    formatTime(num) {
      return num < 10 ? `0${num}` : `${num}`
    },
    // 获取当前服务器时间（修正后的时间）
    getServerTime() {
      return Date.now() + this.serverTimeOffset
    },
    // 计算倒计时文本和状态
    calculateCountdown(item) {
      const now = this.getServerTime() // 使用服务器时间
      const startTime = item.startTime
      const endTime = item.endTime
      // 如果活动还未开始
      if (now < startTime) {
        const diff = startTime - now
        const hours = Math.floor(diff / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((diff % (1000 * 60)) / 1000)
        return {
          text: `${this.formatTime(hours)}:${this.formatTime(minutes)}:${this.formatTime(seconds)}后开始`,
          status: 'upcoming'
        }
      } else if (now >= startTime && now < endTime) {
        // 如果活动进行中
        const diff = endTime - now
        const hours = Math.floor(diff / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((diff % (1000 * 60)) / 1000)
        return {
          text: `${this.formatTime(hours)}:${this.formatTime(minutes)}:${this.formatTime(seconds)}后结束`,
          status: 'ongoing'
        }
      } else {
        // 如果活动已结束
        return {
          text: '活动已结束',
          status: 'ended'
        }
      }
    },
    // 更新所有活动的倒计时
    updateCountdown() {
      let needRefresh = false
      this.flashSaleList.forEach(item => {
        const oldStatus = item.countdownStatus
        const countdown = this.calculateCountdown(item)
        item.countdownText = countdown.text
        item.countdownStatus = countdown.status

        // 检测状态变化：从 upcoming 变为 ongoing，或从 ongoing 变为 ended
        if (oldStatus && oldStatus !== countdown.status) {
          if ((oldStatus === 'upcoming' && countdown.status === 'ongoing') ||
              (oldStatus === 'ongoing' && countdown.status === 'ended')) {
            needRefresh = true
          }
        }
      })

      // 如果有状态变化，刷新接口
      if (needRefresh) {
        this.queryAllflashSale()
      }
    },
    // 启动倒计时定时器
    startCountdownTimer() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      // 立即更新一次
      this.updateCountdown()
      this.timer = setInterval(() => {
        this.updateCountdown()
      }, 1000)
    },
    // 筛选skus对象数组中对象的property属性是最小值的对象
    minRetailPrice(skus, property) {
      let min = ''
      let minIndex = ''
      for (let i = 0; i < skus.length; i++) {
        const el = skus[i]
        if (el.display === '1' && (min === '' || el[property] < min)) {
          min = el[property]
          minIndex = i
        }
      }
      if (minIndex === '') {
        return {}
      } else {
        return skus[minIndex]
      }
    },
    // 查询所有秒杀
    queryAllflashSale(isLoadMore = false) {
      if (this.loading) return
      this.loading = true

      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryActivityList))
      apiObj.param = {
        page: isLoadMore ? this.currentPage : 0,
        size: this.pageSize,
        activityTypeList: [4],
        statusOrder: this.statusOrder,
        sort: [{
          direction: 'DESC',
          property: 'sortId'
        }]
      }
      http.postFrontMall(apiObj).then((res) => {
        const { code, message, value } = res.data
        if (Number(code) === 0) {
          value.content.forEach((commodity) => {
            if (!commodity.shopCommodityList || !Array.isArray(commodity.shopCommodityList)) {
              commodity.progress = 0
              return
            }
            // 遍历 shopCommodityList 数组中的每个商品
            commodity.shopCommodityList.forEach((shop) => {
              if (!shop.activitySkus || !Array.isArray(shop.activitySkus)) {
                return
              }
              // 如果活动未开始，进度条设置为0
              if (this.statusOrder === 2) {
                shop.progress = 0
                return
              }
              // 累加销量
              const shopSale = shop.activitySkus.reduce((total, sku) => {
                if (Number(sku.display) === 0) {
                  return total
                }
                return total + (sku.initSalesNumber || 0) + (sku.salesNumber || 0)
              }, 0)
              // 累加库存
              const shopStock = shop.activitySkus.reduce((total, sku) => {
                if (Number(sku.display) === 0) {
                  return total
                }
                return total + (sku.initGroupStock || 0)
              }, 0)
              shop.progress = Number(((shopSale / shopStock) * 100).toFixed(2))
            })
          })
          // 处理 activityImg,只取第一个图片地址，并过滤只展示预热时间内的活动
          const newData = value.content
            .map(item => ({
              ...item,
              imgUrl: item.activityImg ? item.activityImg.split(',')[1] : '',
              countdownText: '',
              countdownStatus: ''
            }))
            .filter(item => this.isActivityVisible(item)) // 只展示在预热时间到结束时间之间的活动

          if (isLoadMore) {
            // 加载更多，追加数据
            this.flashSaleList = [...this.flashSaleList, ...newData]
          } else {
            // 首次加载或切换标签，替换数据
            this.flashSaleList = newData
            this.currentPage = 0
            this.noMore = false
          }

          this.totalPages = value.totalPages

          // 判断是否还有更多数据
          if (newData.length === 0 || this.currentPage >= this.totalPages - 1) {
            this.noMore = true
          }

          // 启动倒计时定时器
          this.startCountdownTimer()
        } else {
          this.$message(message)
        }
      }).catch(() => {
        this.$message.error('加载数据失败，请稍后重试')
      }).finally(() => {
        this.loading = false
        // 在 loading 设置为 false 之后，检查是否需要自动加载
        this.$nextTick(() => {
          this.checkAndLoadMore()
        })
      })
    },
    // 判断活动是否在可展示时间范围内（开始时间前10分钟开始展示，包括已结束的活动）
    isActivityVisible(item) {
      this.PREHEAT_TIME = item.preheatTime * 60 * 1000
      const now = Date.now()
      const startTime = item.startTime
      const preheatStartTime = startTime - this.PREHEAT_TIME // 预热开始时间
      // 只过滤掉未到预热时间的活动，已结束的活动也展示
      return now >= preheatStartTime
    },
    handleTab(item, index) {
      this.currentIndex = index
      this.statusOrder = item.value
      // 保存到 Vuex
      this.$store.commit('pt/setTimeLimitStatusOrder', this.statusOrder)
      this.queryAllflashSale()
    },
    // 立即抢购
    handleBuy(item, commodityId) {
      this.$router.push({
        name: 'timeLimitDetail',
        params: {
          activityId: item.activityId,
          commodityId: commodityId
        }
      })
    },
    // 查看更多
    handleLook(item) {
      if (item.countdownStatus === 'ended') {
        this.$message('活动已结束')
        return
      }
      this.$store.commit('pt/setGroupActivityId', item.activityId)
      // 保存当前状态到 Vuex
      this.$store.commit('pt/setTimeLimitStatusOrder', this.statusOrder)
      this.$router.push({
        name: 'timeLimitList',
        params: {
          fromStatusOrder: this.statusOrder
        }
      })
    },
    handleEnd(item) {
      if (item.countdownStatus === 'ended') {
        this.$message('活动已结束')
        return
      }
    },
    // 加载更多数据
    loadMore() {
      if (this.loading || this.noMore) return
      this.currentPage++
      this.queryAllflashSale(true)
    },
    // 检查页面是否有滚动条，如果没有且还有更多数据，自动加载
    checkAndLoadMore() {
      const appContainer = document.querySelector('#app')
      if (!appContainer) return

      const hasScrollbar = appContainer.scrollHeight > appContainer.clientHeight

      // 如果没有滚动条且还有更多数据，自动加载下一页
      if (!hasScrollbar && !this.noMore && !this.loading) {
        this.loadMore()
      }
    }
  }
}
</script>
<style scoped lang="scss">
  #timeLimit {
    background: #F4F4F4;
    min-height: calc(100vh - 40px);
    padding-bottom: 50px;
    position: relative;
    .tabBox {
      position: absolute;
      width: 150px;
      height: 192px;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      left: 208px;
      top: 500px;
      display: flex;
      flex-direction: column;
      z-index: 100;
      // transition: all 0.3s ease;
      .item {
        flex: 1;
        font-family: PingFang TC, PingFang TC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .active {
        background: #FE6E4B;
        color: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
      }
      // 固定在顶部的样式
      &.tab-fixed {
        position: fixed;
        top: 100px;
      }
    }
    .masterMap {
      width: 100%;
      height: 400px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .goBack {
        position: absolute;
        top: 30px;
        left: 50px;
        width: 40px;
        height: 40px;
        cursor: pointer;
      }
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      position: relative;
      .titleBox {
        width: 100%;
        text-align: center;
        position: relative;
        font-weight: 500;
        margin-top: 50px;
        .title {
          color: #333333;
          font-size: 20px;
          position: relative;
          .decoration {
            position: absolute;
            width: 10px;
            height: 10px;
            background: linear-gradient( 270deg, #F78C4B 34.62%, #EB4424 88.46%);
            border-radius: 50%;
            top: 50%;
            transform: translateY(-50%);
            .decoration-line {
              position: absolute;
              width: 6px;
              height: 6px;
              background: #F78C4B;
              top: 50%;
              transform: translateY(-50%);
            }
            &.left {
              left: -20px;
              .decoration-line {
                border-radius: 6px 0 0 6px;
                left: -4px;
              }
            }
            &.right {
              right: -20px;
              .decoration-line {
                border-radius: 0 6px 6px 0;
                right: -4px;
              }
            }
          }
          .decoration_left {
            background: linear-gradient( 270deg, #EB4424 34.62%, #F78C4B 88.46%);
          }
        }
      }
      .limitList {
        width: 100%;
        margin-top: 24px;
        .limitImg {
          width: 100%;
          height: 324px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .look {
            position: absolute;
            right: 27px;
            bottom: 25px;
            font-family: PingFang TC, PingFang TC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            cursor: pointer;
          }
          .time {
            position: absolute;
            top: 8px;
            left: 0px;
            min-width: 128px;
            height: 32px;
            border-radius: 0px 12px 12px 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 12px;
            span {
              font-family: PingFang TC, PingFang TC;
              font-weight: 500;
              font-size: 14px;
              color: #FFFFFF;
            }
            // 活动进行中 - 红色
            &.time-ongoing {
              background: #FF0B58;
            }
            // 活动即将开始 - 橙色
            &.time-upcoming {
              background: #FE6E4B;
            }
          }
        }
        .limitItem {
          width: 100%;
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          gap: 21px;
          .limitItemBox {
            width: 284px;
            height: 380px;
            background: #FFFFFF;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            .img {
              width: 100%;
              height: 268px;
              background: #E4E4E4;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .soldOut {
                position: absolute;
                width: 200px;
                height: 200px;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
              }
            }
            .info {
              padding: 10px;
              .storeCommodity {
                display: flex;
                align-items: center;
                gap: 6px;
                img {
                  height: 16px;
                }
                .commodityName {
                  font-size: 14px;
                  color: #333333;
                  flex: 1;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
              .progressBar {
                margin: 11px 0;
                /deep/ .el-progress-bar__outer {
                  border: 1px solid #fce6e1;
                }
                /deep/ .el-progress__text {
                  font-size: 12px !important;
                }
              }
              .price {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .price-box {
                  .current-price {
                    font-family: PingFang TC, PingFang TC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #EB6643;
                  }
                  .original-price {
                    font-family: PingFang TC, PingFang TC;
                    font-weight: 400;
                    font-size: 12px;
                    color: #999999;
                    text-decoration: line-through;
                  }
                }
                .btn {
                  width: 74px;
                  height: 26px;
                  background: linear-gradient( 270deg, #EE8C54 0%, #EA553C 100%);
                  border-radius: 17px;
                  font-family: PingFang TC, PingFang TC;
                  font-weight: 400;
                  font-size: 14px;
                  color: #FFFFFF;
                  text-align: center;
                  line-height: 26px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
      .noData {
        width: 100%;
        height: 200px;
        color: #333333;
        font-size: 18px;
        text-align: center;
        line-height: 200px;
      }
    }
    .loadingTip {
      width: 1200px;
      margin: 20px auto;
      text-align: center;
      font-size: 14px;
      color: #999999;
      .loading {
        color: #1571DB;
      }
      .noMore {
        color: #999999;
      }
    }
  }
</style>
